import { css } from "@emotion/react"
import Spinner from "./Spinner"

const componentStyle = css`
    .loadingBlocker {
        display: block;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1051;
    }

    .spinner {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        left: 50%;
        transform: translateX(-50%);
        z-index: 10512;
    }
`

const Loader = ({ show = true }) => {
    return (
        <div css={componentStyle}>
            {show && (
                <>
                    <div className="loadingBlocker" />
                    <div className="spinner">
                        <Spinner color="#ffffff" />
                    </div>
                </>
            )}
        </div>
    )
}

export default Loader
